import { useCallback, useState } from 'react'

interface UseUnsavedChangesGuardResult {
  showUnsavedChangesDialog: boolean
  attemptAction: (hasUnsavedChanges: boolean, action: () => void, dispose: () => void) => void
  confirmDiscard: () => void
  cancelDiscard: () => void
}

export const useUnsavedChangesGuard = (): UseUnsavedChangesGuardResult => {
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false)
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null)
  const [disposeAction, setDisposeAction] = useState<(() => void) | null>(null)

  const attemptAction = useCallback(
    (hasUnsavedChanges: boolean, action: () => void, dispose: () => void) => {
      if (hasUnsavedChanges) {
        setPendingAction(() => action)
        setDisposeAction(() => dispose)
        setShowUnsavedChangesDialog(true)
        return
      }
      action()
    },
    [],
  )

  const confirmDiscard = useCallback(() => {
    pendingAction?.()
    setPendingAction(null)
    setDisposeAction(null)
    setShowUnsavedChangesDialog(false)
  }, [pendingAction])

  const cancelDiscard = useCallback(() => {
    disposeAction?.()
    setPendingAction(null)
    setDisposeAction(null)
    setShowUnsavedChangesDialog(false)
  }, [disposeAction])

  return {
    showUnsavedChangesDialog,
    attemptAction,
    confirmDiscard,
    cancelDiscard,
  }
}
